<template>
    <div>
        <div style="margin-bottom:20px">
        <el-tag size="medium" style="margin-bottom:20px;margin-right:20px">
             <el-checkbox v-model="checkAll"  @change="handleCheckAllChange">全选</el-checkbox>
        </el-tag>
        <div class="TreeTitle">
          <div>菜单名称：</div>
          <div>菜单描述：</div>
        </div>
        <el-tree
            @check-change="handleCheckChange"
            ref="organizationData"
            :data="tableData"
            show-checkbox
            node-key="id"
            :check-strictly="nodeFlag"
            >
            <span class="TreeConxt" slot-scope="{ node, data }" >
              <div class="TreeCon">
                  <div :title="data.name">{{data.name}}</div>
                  <div :title="data.description">{{data.description}}</div>
              </div>
            </span>
        </el-tree>
        </div>
        <div style="text-align:center;">
            <el-button @click="$emit('update:visibles',false)">取 消</el-button>
             <el-button type="primary" @click="submit()">提 交</el-button>
        </div>
    </div>
</template>
<script>
export default {
  components: {

  },
  props: {
    row: {
      type: Object
    }
  },
  data () {
    return {
      checkedKeyArr: [],
      checkAll: false,
      nodeFlag: false,
      tableData: [],
      // 初始化数据
      AllcheckedKeyLList: [],
      // 所有节点信息
      AllNodeInformation: [],
      // 回显数据
      checkedId: [],
      // 定时器
      TreeSetVal: null
    }
  },
  methods: {
    // 全选
    handleCheckAllChange (val) {
      if (this.checkAll) {
        this.$refs.organizationData.setCheckedNodes(this.tableData)
        // 获取所有节点信息
        this.AllcheckedKeyLList = this.$refs.organizationData.getCheckedKeys().concat(this.$refs.organizationData.getHalfCheckedKeys())
      } else {
        this.$refs.organizationData.setCheckedKeys([])
      }
    },
    // tree复选框
    handleCheckChange (data, checked, indeterminate) {
      this.checkedKeyArr = this.$refs.organizationData.getCheckedKeys().concat(this.$refs.organizationData.getHalfCheckedKeys())
      if (this.AllcheckedKeyLList.length === this.checkedKeyArr.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    // 新增
    add_data () {
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1

      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 列表按钮
    event_button (row, type) {
    },
    Render () {
      this.$http.get('/ucenter/menu/queryTree').then((res) => {
        this.tableData = res.data
        this.traverseArr(res.data)
      })
    },
    // 递归菜单数据
    traverseArr (dataList) {
      if (dataList.length > 0) {
        for (var i in dataList) {
          this.AllcheckedKeyLList.push(dataList[i].id)
          if (dataList[i].children.length > 0) {
            this.traverseArr(dataList[i].children)
          }
        }
      }
    },
    // 提交
    submit () {
      var data = {
        menuIds: this.checkedKeyArr,
        roleId: this.row.id
      }
      this.$http.post('/ucenter/role/saveRoleMenu', data).then((res) => {
        if (res.status === 200) {
          this.$message.success('成功')
          this.$emit('update:visibles', false)
          this.$emit('Render')
        } else {
          this.$message.error('失败')
          this.$emit('update:visibles', true)
        }
      })
    }
  },
  created () {
    // var that = this
    this.Render()
    // setTimeout(() => {
    //   console.log(that.$refs.organizationData.setCheckedNodes(this.row.menuIdList))
    // }, 500)
  },
  watch: {
  },
  mounted () {
    var that = this
    // 解决后台数据返回时携带父id，和部分子id 导致回显时全部选中
    that.TreeSetVal = setInterval(() => {
      that.row.menuIdList.forEach(item => {
        var nodes = that.$refs.organizationData.getNode(item)
        if (nodes.isLeaf) {
          that.$refs.organizationData.setChecked(nodes, true)
        }
      })
      clearInterval(that.TreeSetVal)
    }, 200)
    // setTimeout(() => {
    //   this.$nextTick(function () {
    //     if (that.row.menuIdList) {
    //       console.log(that.row.menuIdList)
    //       const arr = []
    //       that.row.menuIdList.forEach(item => {
    //         if (!that.$refs.organizationData.getNode(item).childNodes || !that.$refs.organizationData.getNode(item).childNodes.length) {
    //           arr.push(item)
    //         }
    //       })
    //       that.$refs.organizationData.setCheckedKeys(arr)
    //     }
    //   })
    // }, 400)
  }
}
</script>
<style lang="scss" scoped>
  .TreeTitle{
    display: flex;
    justify-content: space-between;
    padding: 0 224px 10px 25px;
  }
.TreeConxt{
    .TreeCon{
      display:flex;
      justify-content: space-between;
      div:first-of-type{
        width: 300px;
        margin-right: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      div:last-of-type{
        width: 300px;
        font-size: 12px;
        color: rgb(160, 160, 160);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
    }
}
</style>
